import React from "react";

const ModalFooter = ({ children }) => {
  return <footer className='py-4 px-3 border-t border-black-200 flex justify-end gap-4 dark:border-black-800'>{children}</footer>;
};

export default ModalFooter;
